import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

const ContextMenu = ({
  x,
  y,
  onClose,
  onCopy,
  onPaste,
  id,
  target,
  item,
  cellData,
  onDuplicate,
  onDelete,
  forDirectModules = false,
  isFillerProduct = false,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const itemType = item?.type || "item";
  const columnName = cellData?.column;
  const getClipboardData = (target) => {
    try {
      if (target === "row") {
        const text = localStorage.getItem("copiedObjects");
        return JSON.parse(text);
      } else if (target === "cell") {
        const text = localStorage.getItem("copiedCellData");
        return JSON.parse(text);
      }
    } catch (err) {
      return null;
    }
    return null;
  };

  const isPasteAllowed = (target, item, cellData, clipboard) => {
    if (!item || !clipboard) return false;
    if (forDirectModules) return true;

    if (target === "row") {
      const source = clipboard.items?.[0];
      if (!source) return false;
      const sourceType = source.type;
      const targetType = item.type;

      if (sourceType === "module" && targetType === "module") return true;
      if (
        (sourceType === "module" && targetType === "group") ||
        targetType === "section"
      )
        return true;
      return false;
    }

    if (target === "cell") {
      const src = clipboard.copy_data;
      const dst = cellData;
      if (!src || !dst) return false;

      return src.type === dst.type && src.column === dst.column;
    }

    return false;
  };

  const clipboard = getClipboardData(target);
  const pasteAllowed = isPasteAllowed(target, item, cellData, clipboard);

  const getPasteLabel = () => {
    const item = clipboard?.items?.[0];
    const sect = item?.type === "module" ? "module" : "section";

    if (forDirectModules && item) {
      return `Paste ${sect} directly into the room`;
    }

    if (target === "cell" && clipboard?.copy_data) {
      const { column } = clipboard.copy_data;
      const columnDisplayName = column === "property" ? "spec" : column;
      return `Paste ${columnDisplayName}`;
    }
    if (target === "cell" && !clipboard?.copy_data) {
      const columnDisplayName =
        cellData.column === "property" ? "spec" : cellData.column;
      return `Paste ${columnDisplayName}`;
    }
    if (target === "row" && item) {
      return `Paste ${sect}`;
    }
    return "Paste";
  };

  const renderMenuItem = (label, onClick, disabled = false) => {
    const baseStyle = {
      padding: "8px 12px",
      cursor: disabled ? "not-allowed" : "pointer",
      borderBottom: "1px solid #ddd",
      backgroundColor: "#fff",
      opacity: disabled ? 0.5 : 1,
    };

    return (
      <div
        key={label}
        style={baseStyle}
        onClick={() => {
          if (!disabled) {
            onClick();
            onClose();
          }
        }}
      >
        {label}
      </div>
    );
  };

  const menuItems = [];

  if (target === "row") {
    const type = itemType === "module" ? "module" : "section";

    if (!forDirectModules) {
      menuItems.push(renderMenuItem(`Copy ${type}`, onCopy));
    }
    let disablePaste = forDirectModules ? false : !pasteAllowed;
    menuItems.push(renderMenuItem(getPasteLabel(), onPaste, disablePaste));

    if (!forDirectModules) {
      menuItems.push(renderMenuItem(`Duplicate ${type}`, onDuplicate));
      if (!isFillerProduct) {
        menuItems.push(renderMenuItem(`Delete ${type}`, onDelete));
      }
    }
  } else if (target === "cell" && columnName) {
    const columnDisplayName = columnName === "property" ? "spec" : columnName;
    let type = itemType == "module" ? itemType : "section";
    menuItems.push(renderMenuItem(`Copy ${columnDisplayName}`, onCopy));
    menuItems.push(renderMenuItem(getPasteLabel(), onPaste, !pasteAllowed));
  }
  const menu = (
    <div
      ref={menuRef}
      style={{
        position: "fixed",
        left: `${x}px`,
        top: `${y}px`,
        backgroundColor: "white",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        zIndex: 9999,
        minWidth: "180px",
      }}
    >
      {menuItems}
    </div>
  );
  return ReactDOM.createPortal(menu, document.body);
};

export default ContextMenu;
